//#region src/router/routes.ts
var HomeRoutes = { HOME: "/home" };
//#endregion
export { HomeRoutes };

//# sourceMappingURL=routes.js.map